import { render, staticRenderFns } from "./ConversationDetails.vue?vue&type=template&id=0e8178e4&"
import script from "./ConversationDetails.vue?vue&type=script&lang=js&"
export * from "./ConversationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConversationDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VOverlay,VProgressCircular,VTextarea})
